(function () {
  if (window.__ZT_GLOBO_REVIEW_BRIDGE__) return;
  window.__ZT_GLOBO_REVIEW_BRIDGE__ = true;

  // Hide review stars only inside the Globo collection product grid.
  // The return below disables the old review injection without deleting
  // the rest of the file or modifying Globo's product-card structure.
  const style = document.createElement('style');

  style.id = 'zt-hide-globo-product-card-reviews';
  style.textContent = `
    #gf-products .spf-product-card .collection-icon-list.vstar-star,
    #gf-products .spf-product-card .vstar-star,
    #gf-products .spf-product-card .zt-cloned-review {
      display: none !important;
    }
  `;

  document.head.appendChild(style);

  return;

  const reviewCache = new Map();
  let runTimer = null;

  function debounceRun(fn, delay) {
    clearTimeout(runTimer);
    runTimer = setTimeout(fn, delay);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function buildStarSvg() {
    return '<svg class="trustoo-rating-icon" width="24" height="24" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#FFA800" d="M7.09194 1.53428C7.44936 0.759408 8.55064 0.759406 8.90806 1.53428L10.3048 4.56237C10.4504 4.87817 10.7497 5.09562 11.0951 5.13657L14.4066 5.5292C15.254 5.62967 15.5943 6.67706 14.9678 7.25642L12.5195 9.52052C12.2642 9.75665 12.1499 10.1085 12.2177 10.4496L12.8675 13.7203C13.0339 14.5573 12.1429 15.2046 11.3983 14.7878L8.48844 13.159C8.18497 12.9892 7.81503 12.9891 7.51156 13.159L4.60172 14.7878C3.85711 15.2046 2.96615 14.5573 3.13245 13.7203L3.78235 10.4496C3.85012 10.1085 3.73581 9.75665 3.48047 9.52052L1.0322 7.25643C0.4057 6.67706 0.746015 5.62967 1.59341 5.5292L4.9049 5.13657C5.25027 5.09562 5.54955 4.87817 5.69522 4.56237L7.09194 1.53428Z"></path></svg>';
  }

  function buildReviewHtml(rating, reviewCount) {
    const safeRating = Math.max(0, Math.min(5, Number(rating) || 0));
    const safeCount = Math.max(0, parseInt(reviewCount, 10) || 0);
    const fullStars = Math.max(0, Math.min(5, Math.round(safeRating)));

    let starsHtml = '';
    for (let i = 0; i < 5; i += 1) {
      if (i < fullStars) {
        starsHtml += '<div class="star-item">' + buildStarSvg() + '</div>';
      }
    }

    return (
      '<div class="collection-icon-list vstar-star zt-cloned-review" style="margin-top:5px;margin-bottom:5px;" data-review-num="' + escapeHtml(safeCount) + '" rating="' + escapeHtml(safeRating.toFixed(1)) + '">' +
        starsHtml +
        '<div class="tt-rating-text collection-reviews-num"> (' + escapeHtml(safeCount) + ')</div>' +
      '</div>'
    );
  }

  function findAggregateRating(node) {
    if (!node || typeof node !== 'object') return null;

    if (Array.isArray(node)) {
      for (const item of node) {
        const found = findAggregateRating(item);
        if (found) return found;
      }
      return null;
    }

    if (node.aggregateRating && typeof node.aggregateRating === 'object') {
      const agg = node.aggregateRating;
      const ratingValue = agg.ratingValue || agg.ratingvalue || agg.bestRating || agg.rating;
      const reviewCount = agg.reviewCount || agg.reviewcount || agg.ratingCount || agg.ratingcount;

      if (ratingValue != null && reviewCount != null) {
        return {
          rating: ratingValue,
          count: reviewCount
        };
      }
    }

    for (const key of Object.keys(node)) {
      const found = findAggregateRating(node[key]);
      if (found) return found;
    }

    return null;
  }

  function getNativeReviewInCard(card) {
    const nodes = card.querySelectorAll('.collection-icon-list.vstar-star, .vstar-star');
    for (const node of nodes) {
      if (!node.classList.contains('zt-cloned-review') && node.querySelector('.star-item')) {
        return node;
      }
    }
    return null;
  }

  function cleanupCardReviews(card) {
    const allReviews = Array.from(card.querySelectorAll('.collection-icon-list.vstar-star, .vstar-star'));
    if (!allReviews.length) return;

    const nativeReviews = allReviews.filter(function (node) {
      return !node.classList.contains('zt-cloned-review') && node.querySelector('.star-item');
    });

    const clonedReviews = allReviews.filter(function (node) {
      return node.classList.contains('zt-cloned-review');
    });

    if (nativeReviews.length > 0) {
      clonedReviews.forEach(function (node) {
        node.remove();
      });

      nativeReviews.forEach(function (node, index) {
        if (index > 0) node.remove();
      });

      return;
    }

    clonedReviews.forEach(function (node, index) {
      if (index > 0) node.remove();
    });
  }

  async function getReviewHtmlFromProductPage(productUrl) {
    if (!productUrl) return '';

    const cleanUrl = new URL(productUrl, window.location.origin).pathname;

    if (reviewCache.has(cleanUrl)) {
      return reviewCache.get(cleanUrl);
    }

    try {
      const cached = sessionStorage.getItem('zt_globo_review_' + cleanUrl);
      if (cached !== null) {
        reviewCache.set(cleanUrl, cached);
        return cached;
      }
    } catch (e) {}

    let finalHtml = '';

    try {
      const response = await fetch(cleanUrl, {
        method: 'GET',
        credentials: 'same-origin'
      });

      if (!response.ok) {
        reviewCache.set(cleanUrl, '');
        return '';
      }

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const nativeTrustooBlock =
        doc.querySelector('.collection-icon-list.vstar-star') ||
        doc.querySelector('.vstar-star');

      if (nativeTrustooBlock && nativeTrustooBlock.querySelector('.star-item')) {
        finalHtml = nativeTrustooBlock.outerHTML.replace(
          /class="([^"]*\bvstar-star\b[^"]*)"/,
          'class="$1 zt-cloned-review"'
        );
      } else {
        const jsonLdScripts = Array.from(doc.querySelectorAll('script[type="application/ld+json"]'));
        let found = null;

        for (const script of jsonLdScripts) {
          try {
            const parsed = JSON.parse(script.textContent);
            found = findAggregateRating(parsed);
            if (found) break;
          } catch (e) {}
        }

        if (found && found.rating != null && found.count != null) {
          finalHtml = buildReviewHtml(found.rating, found.count);
        }
      }
    } catch (e) {
      finalHtml = '';
    }

    reviewCache.set(cleanUrl, finalHtml);

    try {
      sessionStorage.setItem('zt_globo_review_' + cleanUrl, finalHtml);
    } catch (e) {}

    return finalHtml;
  }

  async function hydrateCard(card) {
    if (!card) return;

    cleanupCardReviews(card);

    const nativeReview = getNativeReviewInCard(card);
    if (nativeReview) {
      card.dataset.ztReviewReady = '1';
      return;
    }

    const existingClone = card.querySelector('.zt-cloned-review');
    if (existingClone) {
      card.dataset.ztReviewReady = '1';
      return;
    }

    if (card.dataset.ztReviewLoading === '1') return;
    card.dataset.ztReviewLoading = '1';

    const info =
      card.querySelector('.spf-product__info') ||
      card.querySelector('.spf-product-card__info') ||
      card.querySelector('.spf-product-card__meta');

    const title =
      card.querySelector('.spf-product-card__title') ||
      card.querySelector('.spf-product__title');

    const price =
      card.querySelector('.spf-product-card__price-wrapper') ||
      card.querySelector('.spf-product-card__price') ||
      card.querySelector('.spf-product__price');

    const titleLink =
      card.querySelector('.spf-product-card__title a') ||
      card.querySelector('.spf-product__title a') ||
      card.querySelector('.spf-product-card__image-wrapper');

    if (!info || !title || !price || !titleLink) {
      card.dataset.ztReviewLoading = '0';
      return;
    }

    const href = titleLink.getAttribute('href');
    if (!href) {
      card.dataset.ztReviewLoading = '0';
      return;
    }

    const reviewHtml = await getReviewHtmlFromProductPage(href);

    cleanupCardReviews(card);

    if (!card.querySelector('.zt-cloned-review') && !getNativeReviewInCard(card) && reviewHtml) {
      const temp = document.createElement('div');
      temp.innerHTML = reviewHtml.trim();
      const reviewNode = temp.firstElementChild;

      if (reviewNode) {
        price.parentNode.insertBefore(reviewNode, price);
      }
    }

    cleanupCardReviews(card);
    card.dataset.ztReviewLoading = '0';
    card.dataset.ztReviewReady = '1';
  }

  function run() {
    const cards = document.querySelectorAll('#gf-products .spf-product-card');
    cards.forEach(function (card) {
      hydrateCard(card);
    });
  }

  function schedule() {
    debounceRun(function () {
      run();
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);

  const observer = new MutationObserver(function () {
    schedule();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();